import { Injectable } from '@angular/core';
import { environment as env } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor() { }

  public static error(...args: any[]) {
    if (env.debugLogging) {
      console.error(...args);
    }
  }
  public static warn(...args: any[]) {
    if (env.debugLogging) {
      console.warn(...args);
    }
  }
  public static info(...args: any[]) {
    if (env.debugLogging) {
      console.log(...args);
    }
  }
  public static debug(...args: any[]) {
    this.info(...args);
  }
  public static trace(...args: any[]) {
    this.info(...args);
  }
}
